import {
  mediaQueryStyles,
  constants,
  typographyStyles,
} from "@newsela/angelou";

const { mediaQuery: breakpoint } = mediaQueryStyles;
const { heading4Obj, textMObj } = typographyStyles;
const { ui } = constants.colors;

export const archiveContainerCss = {
  marginRight: "auto",
  width: "100%",
  [breakpoint.downTo(constants.breakpoints.BreakpointNames.sm)]: {
    width: "initial",
  },
  checkbox: {
    backgroundColor: ui.neutral[25],
    [breakpoint.downTo(constants.breakpoints.BreakpointNames.sm)]: {
      backgroundColor: "initial",
    },
  },
};

export const modalCss = {
  root: {
    zIndex: 15,
  },
  modalContentWrapper: {
    [breakpoint.downTo(constants.breakpoints.BreakpointNames.xs)]: {
      maxWidth: 800,
      maxHeight: 600,
    },
  },
  scrollableBody: {
    flex: 1,
    h2: {
      ...heading4Obj,
      marginTop: 5,
    },
  },
  footer: {
    display: "flex",
    flexDirection: "column",
    gap: 10,
    [breakpoint.downTo(constants.breakpoints.BreakpointNames.sm)]: {
      flexDirection: "row",
    },

    button: {
      [breakpoint.upTo(constants.breakpoints.BreakpointNames.xs)]: {
        width: "100%",
      },
    },
  },
};

export const resultsContainerCss = {
  display: "flex",
  flexDirection: "column",
  gap: 10,
};

export const centerContainerCss = {
  display: "flex",
  width: "100%",
  height: "100%",
  alignItems: "center",
  justifyContent: "center",
  span: {
    ...textMObj,
    color: ui.neutral[500],
  },
};
